import { Navigate } from 'react-router-dom';
import { getIntelAuth, canIntelTab, firstIntelPath } from '../../utils/intelPerms';

// Route gate for Intelligence pages: admins pass, team members need the
// matching intel tab permission on their role. Denied -> first allowed
// intelligence tab, or back to the dashboard if none.
export const IntelRoute = ({ tab, children }) => {
  const auth = getIntelAuth();
  if (!auth.authed) return <Navigate to="/login" replace />;
  if (canIntelTab(tab)) return children;
  return <Navigate to={firstIntelPath()} replace />;
};
